import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { ERPViewModel } from '../../ViewModels';
import { PostQuickbooksExchangeParams } from './Params';

/**
 * API for ERP systems
 */
export class ERPApi {
    private route = '/ERP';

    public getERPSystems = (): ApiResponse<ERPViewModel[]> => {
        return api().get(`${this.route}`);
    };

    public postQuickbooksExchange = (params: PostQuickbooksExchangeParams): ApiResponse<void> => {
        return api().post(`${this.route}/Quickbooks/Exchange`, params);
    };

    public postQuickbooksRevoke = (erpApiReadConfigurationId: number): ApiResponse<void> => {
        return api().post(`${this.route}/Quickbooks/Revoke`, undefined, {
            params: { erpApiReadConfigurationId },
        });
    };
}
